import axios from 'axios'
export default {
    namespaced: true,
    state: {
		name: 'FleetType',
		endpoint: '/fleet/type',
		icon: 'mdi-car-2-plus',
        items: [],
    },
    actions: {
		load (context) {
			return axios.get(context.getters.endpoint).then(response => {
				context.commit('items', response.data)
			}, error => { console.log(error) })
		},
    }
}